// client/src/inquiries/InquiryCreate.tsx
import React from 'react';
import { Create, SimpleForm, TextInput, NumberInput, DateInput, ReferenceInput, SelectInput, required, useNotify, useRedirect } from 'react-admin';
import useAuthorize from '../hooks/useAuthorize';
import { INQUIRIES_MODULE_ROLES } from '../roles/portalRoles';

export const InquiryCreate = (props: any) => {
    useAuthorize(INQUIRIES_MODULE_ROLES);
    const notify = useNotify();
    const redirect = useRedirect();

    const validateDecimal = (message: string) => (value: any) => {
        if (value == null || value === '') return;
        const regex = /^\d+(\.\d{1,2})?$/;
        return regex.test(String(value)) ? undefined : message;
    };

    const onSuccess = () => {
        notify('Inquiry created successfully', { type: 'info' });
        redirect('/inquiries');
    };

    return (
        <Create {...props} onSuccess={onSuccess}>
            <SimpleForm>
                <DateInput source="inquiry_date" label="Inquiry Date" defaultValue={new Date()} />
                <NumberInput source="inquiry_customer_id" label="Customer ID" validate={[required()]} />
                <NumberInput
                    source="inquiry_quantity"
                    label="Quantity (MT)"
                    step={0.01}
                    validate={[required(), validateDecimal('Quantity must be a valid number up to 2 decimal places')]}
                />
                <NumberInput source="inquiry_price" label="Price" validate={[required()]} />
                <ReferenceInput source="inquiry_status_id" reference="inquiries/getStatus" alwaysOn>
                    <SelectInput optionText="inquiry_status" label="Status" validate={[required()]} />
                </ReferenceInput>
                <NumberInput source="inquiry_product_id" label="Product ID" validate={[required()]} />
                <TextInput source="inquiry_city_name" label="City Name" />
            </SimpleForm>
        </Create>
    );
};

export default InquiryCreate;

